export default "__VITE_ASSET__C$o5uTwc__"